// extracted by mini-css-extract-plugin
export default {"msgButton":"uMMkDnIR_Wgcz3gaYZqh"};